import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useBiLogger } from '../hooks/useBiLogger';
export const withLogBiEvent = (Component)=>{
    const ComponentWithLogBiEvent = (props)=>{
        const logBiEvent = useBiLogger();
        return /*#__PURE__*/ React.createElement(Component, _object_spread_props(_object_spread({}, props), {
            logBiEvent: logBiEvent
        }));
    };
    ComponentWithLogBiEvent.displayName = `WithLogBiEvent(${Component.displayName || Component.name || 'Component'})`;
    return ComponentWithLogBiEvent;
};
export default withLogBiEvent;
